import type { IntlService } from "ember-intl";

export type TOrderCycleStrategy = 'DAYS' | 'EOQ' | 'LT';

export const OrderCycleStrategies: Record<TOrderCycleStrategy, string> = {
  DAYS: 'orderCycleStrategies.DAYS',
  LT: 'orderCycleStrategies.LT',
  EOQ: 'orderCycleStrategies.EOQ'
};

export const OrderCycleStrategiesOptions = Object.keys(OrderCycleStrategies).map(
  (key) => {
    return { key, label: OrderCycleStrategies[key as TOrderCycleStrategy] };
  }
);

export const translatedOptions = (intl: IntlService) =>
  OrderCycleStrategiesOptions.map((o) => ({ ...o, label: intl.t(o.label) }));

export const OrderCycleStrategiesArray: TOrderCycleStrategy[] = Object.keys(
  OrderCycleStrategies
) as TOrderCycleStrategy[];

export default OrderCycleStrategies;
